import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

interface SompoProgressBarProps {
    progress: string;
}

const separatePercentageString = (str: string): Array<string> | null => {
    const regex = /^(\d+)(%|％)$/;
    return regex.exec(str);
};

const SompoProgressBar = (props: SompoProgressBarProps) => {
    const theme = useTheme();
    const isPercentageString = separatePercentageString(props.progress);
    return (
        <>
            <Box
                sx={{
                    height: "5px",
                    width: "100%",
                    bgcolor: "#ddd",
                    borderRadius: "20px",
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        width: !isPercentageString ? "0%" : `${isPercentageString[1]}%`,
                        height: "100%",
                        bgcolor: "primary.main",
                        borderRadius: "20px",
                    }}
                ></Box>
            </Box>
            <Typography variant="body1" sx={{ color: theme.palette.primary.contrastText }}>
                {!isPercentageString ? props.progress : `${props.progress}完了`}
            </Typography>
        </>
    );
};

export default SompoProgressBar;
